module.exports = __webpack_public_path__ + "media/images/MRM_features-route-bb0d2472.png";